// extracted by mini-css-extract-plugin
module.exports = {"component":"RestaurantsPage_component__25Umg","back":"RestaurantsPage_back__1qO4M","header":"RestaurantsPage_header__3RMOw","filters":"RestaurantsPage_filters__1jSUs"};